import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ChevronDownIcon, MailIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { services } from '../data/services';
import { company } from '../data/company';
const linkBase = 'text-[15px] text-navy-800 transition-colors duration-150 ease-out hover:text-navy-950';
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const closeTimer = useRef<number | undefined>(undefined);
  const location = useLocation();
  useEffect(() => {
    setMobileOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);
  const openMenu = () => {
    window.clearTimeout(closeTimer.current);
    setServicesOpen(true);
  };
  const closeMenu = () => {
    closeTimer.current = window.setTimeout(() => setServicesOpen(false), 120);
  };
  const isServiceRoute = location.pathname === '/services' || services.some(service => service.path === location.pathname);
  return <header className="sticky top-0 z-50 w-full" data-id="element-115" data-mp="2rl8cateegj1p">
      <div className="hidden bg-navy-950 md:block" data-id="element-116" data-mp="2rkgfjf92gf9u">
        <div className="mx-auto flex max-w-content items-center justify-between gap-6 px-6 py-2 text-[12px] tracking-wide text-navy-200 lg:px-8" data-id="element-117" data-mp="2mm5798yf6ctq">
          <p data-id="element-118" data-mp="2hpeogdv8d34m">Professional fiduciary, trust, estate and care administration services</p>
          <div className="flex items-center gap-6" data-id="element-119" data-mp="3faswffmahmck">
            <a href={company.phoneHref} className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-120" data-mp="3acivsphsptjk">
              <PhoneIcon className="h-3.5 w-3.5 text-gold-300" aria-hidden="true" data-id="element-121" data-mp="35j6c8trz4cxo" />
              {company.phoneDisplay}
            </a>
            <a href={company.emailHref} className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-122" data-mp="1wpi0ieumw67">
              <MailIcon className="h-3.5 w-3.5 text-gold-300" aria-hidden="true" data-id="element-123" data-mp="1rdtfu6rdaj9n" />
              {company.email}
            </a>
          </div>
        </div>
      </div>

      <div className="border-b border-navy-100 bg-white/95 backdrop-blur" data-id="element-124" data-mp="1wbv1mzg6gwot">
        <div className="mx-auto flex max-w-content items-center justify-between gap-6 px-6 py-4 lg:px-8" data-id="element-125" data-mp="1hmytl2e4fjo7">
          <Link to="/" aria-label={`${company.name} — home`} data-id="element-126" data-mp="1mla47fc8py7h">
            <Logo data-id="element-127" data-mp="18mk2fmeh7acs" />
          </Link>

          <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex" data-id="element-128" data-mp="18lijkvr7xjki">
            <NavLink to="/" className={({
            isActive
          }) => `${linkBase} ${isActive ? 'text-navy-950' : ''}`} data-id="element-129" data-mp="1cpghj34t4obz">
              Home
            </NavLink>
            <NavLink to="/about" className={({
            isActive
          }) => `${linkBase} ${isActive ? 'text-navy-950' : ''}`} data-id="element-130" data-mp="13o8wvnv7rm0d">
              About Us
            </NavLink>

            <div className="relative" onMouseEnter={openMenu} onMouseLeave={closeMenu} data-id="element-131" data-mp="meo6p7hxdjn0">
              <button type="button" aria-expanded={servicesOpen} aria-haspopup="true" onClick={() => setServicesOpen(open => !open)} className={`flex items-center gap-1.5 ${linkBase} ${isServiceRoute ? 'text-navy-950' : ''}`} data-id="element-132" data-mp="hgwesdha5xit">
                Fiduciary Services
                <ChevronDownIcon className={`h-4 w-4 text-navy-400 transition-transform duration-150 ease-out ${servicesOpen ? 'rotate-180' : ''}`} data-id="element-133" data-mp="1051ftd6jz4dx" />
              </button>
              {servicesOpen && <div className="absolute left-1/2 top-full w-[380px] -translate-x-1/2 pt-4" data-id="element-134" data-mp="3gu6x4lirtkjy">
                  <div className="border border-navy-100 bg-white p-2 shadow-[0_18px_40px_-24px_rgba(11,21,38,0.45)]" data-id="element-135" data-mp="3bw5ajqm4z33q">
                    <Link to="/services" className="block px-4 py-3 text-[13px] uppercase tracking-[0.16em] text-gold-600 transition-colors duration-150 ease-out hover:bg-navy-50" data-id="element-136" data-mp="22xm1cs2lsykf">
                      All Fiduciary Services
                    </Link>
                    <div className="h-px bg-navy-100" data-id="element-137" data-mp="2gxwszxbqmh6n" />
                    {services.map(service => <Link key={service.slug} to={service.path} className="block px-4 py-2.5 text-[14px] text-navy-800 transition-colors duration-150 ease-out hover:bg-navy-50 hover:text-navy-950" data-id="element-138" data-mp="1ka0kzgud8u71">
                        {service.name}
                      </Link>)}
                  </div>
                </div>}
            </div>

            <NavLink to="/contact" className={({
            isActive
          }) => `${linkBase} ${isActive ? 'text-navy-950' : ''}`} data-id="element-139" data-mp="15ihu2nzyxf8w">
              Contact Us
            </NavLink>

            <Link to="/contact" className="whitespace-nowrap bg-navy-900 px-5 py-2.5 text-[14px] font-medium text-white transition-colors duration-150 ease-out hover:bg-navy-800" data-id="element-140" data-mp="t1gv47eai6it">
              Request a Consultation
            </Link>
          </nav>

          <button type="button" className="flex h-10 w-10 items-center justify-center border border-navy-200 text-navy-900 lg:hidden" aria-expanded={mobileOpen} aria-label={mobileOpen ? 'Close menu' : 'Open menu'} onClick={() => setMobileOpen(open => !open)} data-id="element-141" data-mp="f2h4wvb4pjkj">
            {mobileOpen ? <XIcon className="h-5 w-5" data-id="element-142" data-mp="3sgc8e660beic" /> : <MenuIcon className="h-5 w-5" data-id="element-143" data-mp="3shn9fy82i85r" />}
          </button>
        </div>
      </div>

      {mobileOpen && <div className="max-h-[calc(100vh-72px)] overflow-y-auto border-b border-navy-100 bg-white px-6 pb-8 pt-2 lg:hidden" data-id="element-144" data-mp="3dtdjahumgw6s">
          <nav aria-label="Mobile" className="flex flex-col" data-id="element-145" data-mp="3it84q5vmotkg">
            <Link to="/" className="border-b border-navy-100 py-3 text-navy-900" data-id="element-146" data-mp="33v61jwsiea3q">
              Home
            </Link>
            <Link to="/about" className="border-b border-navy-100 py-3 text-navy-900" data-id="element-147" data-mp="38t7l0itukbfq">
              About Us
            </Link>
            <Link to="/services" className="border-b border-navy-100 py-3 text-navy-900" data-id="element-148" data-mp="epjz12bpw5m">
              Fiduciary Services
            </Link>
            {services.map(service => <Link key={service.slug} to={service.path} className="border-b border-navy-100 py-3 pl-4 text-[15px] text-navy-600" data-id="element-149" data-mp="3mrpdetup6c3z">
                {service.name}
              </Link>)}
            <Link to="/contact" className="border-b border-navy-100 py-3 text-navy-900" data-id="element-150" data-mp="o4juvd331an8">
              Contact Us
            </Link>
            <Link to="/contact" className="mt-6 bg-navy-900 px-5 py-3 text-center text-[15px] font-medium text-white" data-id="element-151" data-mp="23vm5ebv2njct">
              Request a Consultation
            </Link>
            <a href={company.phoneHref} className="mt-6 flex items-center gap-2 text-[15px] text-navy-800" data-id="element-152" data-mp="2dlykhok4akbk">
              <PhoneIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-153" data-mp="1px5xihlh3mt3" />
              {company.phoneDisplay}
            </a>
            <a href={company.emailHref} className="mt-3 flex items-center gap-2 text-[15px] text-navy-800" data-id="element-154" data-mp="1ywiz6o3cv739">
              <MailIcon className="h-4 w-4 text-gold-500" aria-hidden="true" data-id="element-155" data-mp="1ut4gfpo18cm4" />
              {company.email}
            </a>
          </nav>
        </div>}
    </header>;
}